import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { generateUrl } from 'utils/helpers';
import { apiLoaderQuery } from 'store/query';

const tagType = 'Room Bitwerx';

export const roomBitwerxApi = createApi({
  tagTypes: [tagType],
  baseQuery: apiLoaderQuery,
  reducerPath: 'roomBitwerxApi',
  endpoints: (build) => ({
    list: build.query<any[], any>({
      providesTags: () => [tagType],
      transformResponse: (response: any) => response.data.rooms,
      query: (data: any) => ({
        method: 'get',
        url: generateUrl(URL.GET_BITWERX_ROOM_MASTER_LIST, { id: data.id }),
      }),
    }),
  }),
});

export const { useListQuery } = roomBitwerxApi;
